export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_12.a4eaae9d.jpg";